import { Card } from "@/modules/cards/interfaces/Card";
import { defineStore } from "pinia";
import { ref, toRaw } from "vue";

export const useCardsStore = defineStore("cards", () => {
  const activeCards = ref<Card[]>([]);
  const inactiveCards = ref<Card[]>([]);

  return {
    activeCards,
    inactiveCards,

    setActiveCards(value: Card[]) {
      activeCards.value = toRaw(value);
    },

    setInactiveCards(value: Card[]) {
      inactiveCards.value = toRaw(value);
    },
  };
});
